import * as React from 'react';

import Fields from './Fields';
import { PkpassFieldsType } from '../../../../types';

export default function PrimaryFields(): JSX.Element {
  return <Fields fieldsType={PkpassFieldsType.PrimaryFields} />;
}
